import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';
import Card from "react-bootstrap/Card";

import axios from 'axios'
import { Recommendations, RecommendationSummary } from './Recommendations';
import Feedback from './Feedback';
import { API_BASE_PATH } from './Api';
import FilterComponent from './table/FilterComponent';
import RecommendationsTable from './table/RecommendationsTable';
import { SmartBasket } from './SmartBasket';

function CrossSellRaw({recommendations}){

  const ulStyle = { width: '100%', listStyleType: 'none',padding:'0px' }
  const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee',padding:'10px',margin:"10px" }

  return(
    <ul style={ulStyle}>
        {
          recommendations && recommendations.skuInfo && 
          
          Object.keys(recommendations.skuInfo).map((key)=>(
            <li style={liStyle}>

                <table className="cattable">
              <tr><th>SKU</th><th>Quantity</th></tr>
              <tr><td>{key}</td><td>{recommendations.skuInfo[`${key}`]}</td></tr>

            </table>
              </li>
            
        ))
          
        }   
        
      </ul>
  );
}

export default function Recommendation() {

  var userInfo = localStorage.getItem("userInfo");
  if(userInfo){
    userInfo = JSON.parse(userInfo);
  }

  const getOutletInfo = async () => new Promise((res, rej) => {
    axios.get('http://localhost:8080/crosssell_marsinduat.json')
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });

  const getRecommendations = async (outletCode) => new Promise((res, rej) => {
    axios.get(API_BASE_PATH+`/objects/crossSell2/outletCode/${outletCode}?lob=${userInfo.accountId}`)
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });


  


  const getOutletCode=()=>{
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);
    console.log(searchParams.get('outletCode'));
    return searchParams.get('outletCode')||"";
  }


  const [value, setValue] = useState({value:"x"});
  const [items, setItems] = useState(['one', 'two', 'three']);
  const [outlets, setOutlets] = useState([]);

  const [recommendations, setRecommendations] = useState([]);
  const [data, setData] = useState({});

  const [clusterInfo, setClusterInfo] = useState({});
  const [recordInfo, setRecordInfo] = useState({});
  const [outletClusters, setOutletClusters] = useState([]);

  const [loading, setLoading] = useState(false);
  const [statusInfo, setStatusInfo] = useState({});

  const [filterText, setFilterText] = useState('');
  const [smartBasket,setSmartBasket]=useState(null);
  const [outletCode,setOutletcode]=useState(getOutletCode());


  useEffect(() => {
    
  }, [])



  const getPurchaseBasket = async (outletCode) => new Promise((res, rej) => {
    console.log(API_BASE_PATH+`/objects/spb/outletCode/${outletCode}?lob=${userInfo.accountId}`)
    axios.get(API_BASE_PATH+`/objects/spb/outletCode/${outletCode}?lob=${userInfo.accountId}&resolve=true`)
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });
  
  

  const loadOptions = (inputValue) => {
    console.log("Initial value=>"+inputValue+outlets.length)
    if(!inputValue){
      console.log("Sending default")
      return Promise.resolve(outlets.slice(0,50));
    }  
    //return fetch(`http://jsonplaceholder.typicode.com/posts?userId=${inputValue}`).then(res => res.json());
    return Promise.resolve(outlets.filter(x=>x.value.indexOf(inputValue)!=-1).slice(0,50));
  };

  const loadPurchaseBasket =async (info) => {
    if(info){
      setLoading(true)
      setSmartBasket([]);
      setSmartBasket((await getPurchaseBasket(info)).sort(function(a, b){return a.relevance - b.relevance}).reverse())
      setLoading(false);
    }else{
      setSmartBasket([]);
    }
  };

  return (
    <div className="container mainPanel" >

<div className="row">
<div className="col-md-8 leftPaner" >

<br></br>
      <RecommendationsTable onFilter={loadPurchaseBasket} outletCode={outletCode}/>

     
      
      
      </div>
      <div className="col-md-4 rightPanel">
       {/* {statusInfo &&   <Feedback selectedItem={value} statusInfo={statusInfo} updater={setStatusInfo} loading={setLoading} />} */}


       {
                smartBasket && smartBasket.length>0 && 
                <Card style={{ width: '31rem', margin: "10px" }}>
                  <Card.Body>
                    <Card.Title style={{background:"grey",color:"white",padding:"10px"}}>Outlet Summary</Card.Title>
                    <Card.Text>
                      OutletCode {smartBasket[0].outletCode}
                      <br></br>
                      LoginId {smartBasket[0].loginId}
                    </Card.Text>
                  </Card.Body>
                </Card>
              }
              {
              

               smartBasket && smartBasket.length>0 && <SmartBasket basket={smartBasket}/>

               
              }


          </div>

</div>
    </div>
  );
}

